<panel [refresh]="dataProvider.refreshService">
	<h1>{{ 'company.domains' | translate }}</h1>

	<ng-template #domainList let-filter="filter">
		<list-view [emptyLabel]="'company.domains.domains-list-empty-label'">
			<header defaultSort="ascending">{{ 'domain.name' | translate }}</header>
			<header>{{ 'domain.server' | translate }}</header>
			<header>{{ 'domain.name-server' | translate }}</header>
			<row *listData="let domain from companyDomains" [hidden]="!filter(domain)" [statusColor]="getDomainStatusColor(domain)" [statusIcon]="getDomainStatusIcon(domain)" (action)="(selectedDomain = domain) && buyDomainTargetPlan = undefined" [highlighted]="selectedDomain == domain">
				<column>{{ domain.name }}</column>
				@if (domain.server == undefined) {
					<column><skeleton /></column>
				}
				@else {
					<column>{{ domain.server == '' ? ('general.na' | translate) : domain.server }}</column>
				}
				@if (domain.nameServer == undefined) {
					<column><skeleton /></column>
				}
				@else {
					<column>{{ domain.nameServer == '' ? ('general.na' | translate) : domain.nameServer }}</column>
				}
			</row>
		</list-view>
	</ng-template>

	<scrollable>
		@if (!domainProductPlans) {
			<skeletons [defaultSkeletons]="1" />
		}
		@else if (domainProductPlans.length > 0) {
			<h3>{{ 'company.domains.unused-product-plans' | translate }}</h3>
			<list-view [emptyLabel]="'company.domains.product-plan-list-empty-label'">
				<header defaultSort="ascending">{{ 'domain.product-plan.reference-no' | translate }}</header>
				<header>{{ 'domain.product-plan.name' | translate }}</header>
				<header>{{ 'domain.product-plan.next-period' | translate }}</header>
				<header>{{ 'domain.status' | translate }}</header>
				<row *listData="let productPlan from domainProductPlans" (action)="(buyDomainTargetPlan = productPlan) && selectedDomain = undefined" [highlighted]="buyDomainTargetPlan == productPlan">
					<column>{{ productPlan.accountingPlans[0]?.referenceNo }}</column>
					<column>{{ productPlan | productName }}</column>
					<column>{{ productPlan.nextPeriod }}</column>
					<column>{{ 'domain.status.ready-to-order' | translate }}</column>
				</row>
			</list-view>
		}
		
		@if (!companyDomains) {
			<skeletons [defaultSkeletons]="2" />
		}
		@if (anyRegistrantManagedDomains) {
			<h3>{{ 'company.domains.registrant-managed' | translate }}</h3>
			<ng-container *ngTemplateOutlet="domainList; context: { filter: isRegistrantManaged }" />
			<section *requiredCredential="requestRegistrarManagementCredential">
				<button [loader]="false" [active]="hasValidDomainForRegistrarManagement()" (click)="requestRegistrarManagement()"><icon type="handshake-simple" /> {{ 'company.domains.request-registrar-management' | translate }}</button>
			</section>
		}
		@if (anyRegistrarManagedDomains) {
			<h3>{{ 'company.domains.registrar-managed' | translate }}</h3>
			<ng-container *ngTemplateOutlet="domainList; context: { filter: isRegistrarManaged }" />
		}
	</scrollable>

	<section>
		<button [loader]="false" (click)="addExistingDomain()"><icon type="plus" /> {{ 'company.domains.add-existing-domain' | translate }}</button>
	</section>
</panel>

@if (selectedDomain && !selectedDomain.deleted) {
	<domain-details [domain]="selectedDomain" [companyId]="companyId" />
}
@if (buyDomainTargetPlan) {
	<add-domain [registerNewDomain]="true" [productPlan]="buyDomainTargetPlan" [companyId]="companyId" />
}
